import { render, staticRenderFns } from "./DomainForm.vue?vue&type=template&id=38c7d710&"
import script from "./DomainForm.vue?vue&type=script&lang=js&"
export * from "./DomainForm.vue?vue&type=script&lang=js&"
import style0 from "./DomainForm.vue?vue&type=style&index=0&id=38c7d710&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports